import React from 'react';

/**
 * Component to display a "row" svg icon
 * @param {boolean} is_active - Boolean to determine if the icon is active. If true, an "active" style is applied to the icon
 */
const SvgRowView = (props) => {
  let is_active =
    '.RowView_svg__st1{fill:none;stroke:currentColor;stroke-width:.25;stroke-miterlimit:10;opacity:0.25}.RowView_svg__st2{fill-rule:evenodd;clip-rule:evenodd;opacity:.25}';
  if (props.is_active) {
    is_active =
      '.RowView_svg__st1{fill:none;stroke:currentColor;stroke-width:.25;stroke-miterlimit:10} .RowView_svg__st2{fill-rule:evenodd;clip-rule:evenodd}';
  }

  return (
    <svg
      id="RowView"
      x={0}
      y={0}
      viewBox="0 0 11.25 8.9"
      xmlSpace="preserve"
      width="1.5em"
      height="1.5em">
      <style>{is_active}</style>
      <path
        opacity={0.25}
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M.13.13h11v8.65h-11z"
      />
      <path className="RowView_svg__st1" d="M.13.13h11v8.65h-11z" />
      <circle className="RowView_svg__st2" cx={1.88} cy={1.94} r={1} />
      <path className="RowView_svg__st2" d="M3.88 1.45h6.5v.97h-6.5z" />
      <circle className="RowView_svg__st2" cx={1.88} cy={4.37} r={1} />
      <path className="RowView_svg__st2" d="M3.88 3.89h6.5v.97h-6.5z" />
      <g>
        <circle className="RowView_svg__st2" cx={1.88} cy={6.81} r={1} />
        <path className="RowView_svg__st2" d="M3.88 6.32h6.5v.97h-6.5z" />
      </g>
    </svg>
  );
};

export default SvgRowView;
